module.exports = __webpack_public_path__ + "static/roboto-mono-v7-latin-700-73491684849da6c94511623a2f5ae93d.woff2";